import React, { FC, useState } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { TToastNewState } from 'transfix-ui/components/Toast'
import { ResponsiveLayout } from 'apps/fleet-planner/components/layout/ResponsiveLayout'
import { ResponsiveLayoutRow } from 'apps/fleet-planner/components/layout/ResponsiveLayoutRow'
import { useUserContext } from 'apps/fleet-planner/context/UserContext'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { SETTINGS_TIME_FORMAT } from 'apps/fleet-planner/types'
import { TimeFormatInput } from '../../components/user/TimeFormatInput'

interface IDateAndTimeMobilePageProps {
  /**
   * A function provided by the parent component to navigate to the default page
   */
  onGoToDefaultRoute: () => void

  /**
   * A function provided by the parent component to open the toast on the main page
   */
  onOpenToast?: (options: TToastNewState) => void
}

export const DateAndTimeMobilePage: FC<IDateAndTimeMobilePageProps> = ({
  onGoToDefaultRoute,
  onOpenToast = () => {},
}) => {
  const { trackEvent } = useFMSAnalytics()
  const { errors, timeFormat: initialTimeFormat, updateUserSettings } = useUserContext()
  const [timeFormat, setTimeFormat] = useState<SETTINGS_TIME_FORMAT>(initialTimeFormat)

  const pressBackButtonHandler = () => {
    onGoToDefaultRoute()
  }

  const clickHandler = async () => {
    const payload = {
      settings: {
        timeFormat,
      },
    }
    try {
      await updateUserSettings(payload)
      trackEvent('Settings', 'SAVED_GENERAL_SETTINGS', payload)
      onGoToDefaultRoute()
      onOpenToast({
        toastType: errors ? 'alert' : 'default',
        toastMessage: errors || 'Changes Saved.',
      })
    } catch (error) {
      onOpenToast({
        toastType: 'alert',
        toastMessage: 'Something went wrong.',
      })
    }
  }

  const timeFormatInputChangeHandler = (value: SETTINGS_TIME_FORMAT) => {
    setTimeFormat(value)
  }

  return (
    <ResponsiveLayout
      title='Date and Time'
      onPressBackButton={pressBackButtonHandler}
      footer={
        <Button
          data-test='submit-time-format'
          type='submit'
          color='primary'
          size='large'
          disabled={initialTimeFormat === timeFormat}
          onClick={clickHandler}
          fullWidth>
          Save changes
        </Button>
      }>
      <ResponsiveLayoutRow>
        <TimeFormatInput value={timeFormat} onChange={timeFormatInputChangeHandler} />
      </ResponsiveLayoutRow>
    </ResponsiveLayout>
  )
}
